<template>
  <swiper
    ref="cellListSwiper"
    :options="swiperOptions"
    class="swiper popular-content-list"
  >
    <swiper-slide v-for="(cell, index) in cellList" :key="index">
      <SearchPopularCell
        :cell-info="cell"
        :thumbnail-info="thumbnailInfo"
        :index="index"
      />
    </swiper-slide>
    <div slot="button-prev" class="swiper-button-prev" />
    <div slot="button-next" class="swiper-button-next" />
    <slot name="banner-wrapper" />
  </swiper>
</template>
<script>
  import _ from 'lodash'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import SearchPopularCell from '@/components/search/view/SearchPopularCell'
  import {
    COMMON_SWIPER_OPTIONS,
    SLIDES_PER_GROUP,
  } from '@/common/resources/swiper.const'

  export default {
    name: 'SearchPopularCellList',
    components: {
      SearchPopularCell,
      swiper,
      swiperSlide,
    },
    props: {
      cellList: {
        type: Array,
      },
    },
    data() {
      return {
        thumbnailInfo: {
          width: 360,
          height: 203,
          containerSize: 327,
          placeholderImage: require('../../../assets/images/common/img_default_thum_2.svg'),
        },
        swiperOptions: {
          height: 50,
          spaceBetween: COMMON_SWIPER_OPTIONS.SPACE_BETWEEN,
          slidesPerView: COMMON_SWIPER_OPTIONS.SLIDES_PER_VIEW,
          slidesPerGroup: SLIDES_PER_GROUP.HORIZONTAL_S,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          observer: true,
        },
      }
    },
    computed: {
      swiper() {
        return this.$refs.cellListSwiper.swiper
      },
    },
    beforeDestroy() {
      const destroyFn = _.get(
        this.$refs,
        ['cellListSwiper.$destroy'],
        function () {},
      )
      destroyFn()
    },
  }
</script>
<style lang="scss" scoped>
  .popular-content-list {
    position: relative;
    padding: 0 100px;
    &:before,
    &:after {
      position: absolute;
      left: 0;
      top: 0;
      width: 100px;
      height: 202px;
      background: linear-gradient(
        270deg,
        rgba(244, 245, 246, 0) 0%,
        #1b1b1b 100%
      );
      z-index: 10;
      content: '';
    }
    &:after {
      left: auto;
      right: 0;
      background: linear-gradient(
        90deg,
        rgba(244, 245, 246, 0) 0%,
        #1b1b1b 100%
      );
    }
  }
  .multi {
    .swiper-button-prev,
    .swiper-button-next {
      left: 70px;
      opacity: 0;
    }
    .swiper-button-next {
      left: auto;
      right: 70px;
    }
    &:hover {
      .swiper-button-prev,
      .swiper-button-next {
        left: 100px;
        opacity: 1;
      }
      .swiper-button-next {
        left: auto;
        right: 100px;
      }
      .swiper-button-prev.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
      }
      .swiper-button-next.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
      }
    }
  }
</style>
